"use client";
import { memo, useRef } from "react";

import { CandleChartProps } from "./types";
import { useCandleChart } from "./use-candle-chart";

type CandleChartComponentProps = Omit<CandleChartProps, "containerRef">;

const CandleChart = (props: CandleChartComponentProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useCandleChart({ ...props, containerRef });
  return <div className="candle-chart" ref={containerRef}></div>;
};

const areEqual = (
  prev: CandleChartComponentProps,
  next: CandleChartComponentProps,
) =>
  prev.chartPeriod === next.chartPeriod &&
  prev.viewMode === next.viewMode &&
  prev.isDownTrend === next.isDownTrend &&
  prev.width === next.width;

export default memo(CandleChart, areEqual);
